export default "__VITE_ASSET__CuApov$8__"